import React from "react";

import { LayoutWatcher } from "@common/layoutWatcher";
import { SelectList } from "@common/selectList";
import { Calendar } from "@common/calendar";
import { Props } from "./types";
import styles from "./styles.scss";

function DateInput({ date, edit }: Props) {
  const d = new Date(date);

  return (
    <LayoutWatcher
      renderChildren={({ left, top }) => (
        <SelectList
          rootClassName={styles.dateInput}
          listClassName={styles.list}
          listStyle={{ top }}
        >
          {({ select }) => ({
            input: (
              <p className={styles.text}>{new Date(d).toLocaleDateString()}</p>
            ),
            list: (
              <Calendar
                date={{
                  year: d.getFullYear(),
                  month: d.getMonth(),
                  day: d.getDate(),
                }}
                editDate={(nextDate) => {
                  edit(
                    new Date(
                      nextDate.year,
                      nextDate.month,
                      nextDate.day,
                    ).toISOString(),
                  );
                  select(null);
                }}
              />
            ),
          })}
        </SelectList>
      )}
    />
  );
}

export { DateInput };
